let language = {
    "97110101": "库空间不足",
    "97110010": "根目录不存在",
    "97110011": "目录不存在!",
    "97110019": "该库不属于当前用户",

    "15800101": "文件名不合法，文件名不能包含以下字符：\\ / : * ? \" < > |",
    "15800102": "上传的文件不是图片类型",
    "15800105": "系统错误",
    "fileUploadNetWorkError": "网络连接错误，请检查网络连接状态后重试。",
    "fileUploadUnknownError": "未知错误",
}

export { language }
